module.exports = __webpack_public_path__ + "static/media/news-icon-color.e8c6dda5.svg";